import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  'next-stage-cta': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 36,
    paddingBottom: 80,
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px 80px',
      '&.confirm-chat': {
        padding: '0px',
        paddingBottom: 80
      }
    },
    '& button': {
      maxWidth: 240,
      margin: 4
    }
  },
  'Member-Withdrawal-root': {
    '& .authenticate': {
      [theme.breakpoints.down('md')]: {
        padding: '20px 16px'
      }
    },
    '& .emphasis': {
      color: colorSet.errorMain
    }
  },
  'Member-Withdrawal-ConfirmPassword-root': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 60,
    maxWidth: 360,
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px',
      maxWidth: '100%'
    },
    margin: '0px auto',
    '& .input-root': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginBottom: 20,
      '& .MuiInputBase-root': {
        borderRadius: 8
      },
      '& .MuiInputBase-input': {
        marginRight: 0
      },
      '& .MuiInputBase-root.Mui-disabled': {
        backgroundColor: colorSet.gray100,
        color: colorSet.gray400,
        '-webkit-text-fill-color': colorSet.gray400
      }
    }
  },
  'Member-Withdrawal-ConfirmMembership-root': {
    '& .reason-root': {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: 60,
      [theme.breakpoints.down('md')]: {
        padding: '0px 16px'
      },
      gap: '10px',
      '& .reason': {
        maxWidth: 340,
        width: 'calc(100% / 2 - 5px)',
        height: 60,
        borderRadius: 8,
        border: `1px solid ${colorSet.gray400}`,
        padding: 20,
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
          maxWidth: '100%',
          width: 'calc(100%)'
        },
        '&.active': {
          border: `1px solid ${colorSet.primary500}`,
          backgroundColor: colorSet.primary100
        },
        '&.error': {
          border: `1px solid ${colorSet.errorMain}`
        }
      }
    },
    '& .extra-reason-root': {
      marginBottom: 100,
      [theme.breakpoints.down('md')]: {
        padding: '0px 16px'
      },
      '& .extra-reason-input': {
        backgroundColor: colorSet.gray100,
        padding: 20
      },
      '& .extra-input': {
        backgroundColor: colorSet.gray000,
        borderRadius: 8
      },
      '& .error': {
        marginTop: 10
      }
    },

    '& .check-list-root': {
      [theme.breakpoints.down('md')]: {
        padding: '0px 16px'
      },
      '& .check-list-item': {
        position: 'relative',
        border: `1px solid ${colorSet.gray400}`,
        padding: '22px 20px',
        borderRadius: 8,
        cursor: 'pointer',
        '&.active': {
          border: `1px solid ${colorSet.primary500}`
        },
        '&.error': {
          border: `1px solid ${colorSet.errorMain}`
        },
        '&:not(:last-child)': {
          marginBottom: 20
        },
        '& .strong': {
          color: colorSet.errorMain
        },
        '& .MuiCheckbox-root': {
          position: 'absolute',
          top: 0,
          right: 0,
          padding: '20px',
          [theme.breakpoints.down('md')]: {
            position: 'relative',
            display: 'none'
          }
        },
        '& .MuiFormControlLabel-root': {
          marginLeft: 0,
          marginRight: 0,
          padding: '10px 16px',
          width: '100%',
          backgroundColor: colorSet.gray900,
          borderRadius: 8,
          justifyContent: 'center',
          marginTop: 20,
          '& .MuiFormControlLabel-label': {
            ...theme.typography.body2,
            color: colorSet.gray000
          },
          '&.checked': {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: colorSet.gray000,
            '& .MuiFormControlLabel-label': {
              ...theme.typography.body2,
              color: colorSet.gray900,
              display: 'flex',
              alignItems: 'center',
              '& svg': {
                width: 20,
                height: 20,
                marginRight: 4
              }
            }
          }
        },
        '& .has-sublist': {
          display: 'flex',
          wordBreak: 'break-all',
          '& span': {
            display: 'block',
            marginRight: 6,
            '&.bullet': {
              marginLeft: 6
            }
          }
        },
        '& .sublist-root': {
          marginTop: 20,
          borderTop: `1px solid ${colorSet.gray200}`,
          borderBottom: `1px solid ${colorSet.gray200}`,
          '&>:not(:last-child)': {
            borderBottom: `1px solid ${colorSet.gray200}`
          },
          '& .flex-box': {
            display: 'flex',
            alignItems: 'center',
            width: 132,
            marginRight: 40,
            [theme.breakpoints.down('md')]: {
              marginRight: 40,
              marginBottom: 16
            },
            '& > img': {
              marginRight: 8
            }
          },
          '& .sub-list': {
            padding: `20px 0px`,
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('md')]: {
              flexDirection: 'column',
              alignItems: 'flex-start'
            }
          }
        }
      }
    }
  },
  'Member-Withdrawal-ConfirmChat-root': {
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px'
    },
    '& .MuiCheckbox-root': {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: '0px',
      [theme.breakpoints.down('md')]: {
        position: 'relative',
        display: 'none'
      }
    },
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      marginRight: 0,
      padding: '10px 16px',
      width: '100%',
      backgroundColor: colorSet.gray900,
      borderRadius: 8,
      justifyContent: 'center',
      marginTop: 20,
      '& .MuiFormControlLabel-label': {
        ...theme.typography.body2,
        color: colorSet.gray000
      },
      '&.checked': {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: colorSet.errorLight,
        '& .MuiFormControlLabel-label': {
          ...theme.typography.body2,
          color: colorSet.gray900,
          display: 'flex',
          alignItems: 'center',
          '& svg': {
            width: 20,
            height: 20,
            marginRight: 4
          }
        }
      }
    },
    '& .empty-screen': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      margin: 'auto'
    },
    '& .confirm-chat-tabs-root': {
      width: '100%',
      border: `1px solid ${colorSet.gray400}`,
      padding: '16px 0px 24px',
      height: 596,
      '& .service-tab-root': {
        width: '100%',
        borderBottom: `1px solid ${colorSet.gray200}`,
        '& .MuiTab-root': {
          padding: 15,
          '&.single': {
            width: '100%',
            maxWidth: 'calc(100%)'
          },
          '&.double': {
            width: '100%',
            maxWidth: 'calc(100% / 2)'
          },
          '&.triple': {
            width: '100%',
            maxWidth: 'calc(100% / 3)'
          },
          '& .MuiTab-wrapper': {
            flexDirection: 'row',
            [theme.breakpoints.down('md')]: {
              flexDirection: 'column'
            },
            '& .MuiChip-root': {
              borderRadius: 12,
              minWidth: 42,
              height: 20,
              marginLeft: 6,
              [theme.breakpoints.down('md')]: {
                minWidth: 20,
                height: 20,
                marginLeft: 0,
                marginTop: 6
              },
              '& .MuiChip-label': {
                ...theme.typography.subtitle2,
                color: colorSet.gray900,
                padding: 0
              }
            }
          },
          ...theme.typography.body1,
          fontWeight: 'bold',
          color: colorSet.gray600,
          '&.selected': {
            color: colorSet.gray900
          }
        },
        '& .MuiTabs-indicator': {
          backgroundColor: colorSet.gray900,
          height: 2
        }
      },
      '& .open-chat-list-root': {
        display: 'flex',
        flexDirection: 'column',
        padding: '0px 12px 0px',
        minHeight: 440,
        '& .open-chat-list-item': {
          display: 'flex',
          alignItems: 'center',
          padding: '14px 12px',
          borderBottom: `1px solid ${colorSet.gray400}`,
          maxHeight: 88,
          position: 'relative',
          [theme.breakpoints.down('md')]: {
            padding: '16px 12px 24px'
          },
          '& .thumbnail': {
            borderRadius: '50%',
            border: `1px solid ${colorSet.gray100}`
          },
          '& .company-info': {
            display: 'flex',
            flexDirection: 'column',
            '& .message-preview': {
              textOverflow: 'ellipsis',
              maxWidth: 378,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              [theme.breakpoints.down('md')]: {
                maxWidth: 187
              }
            },
            '&.group-name': {
              marginLeft: 16
            }
          },
          '& .go-chat': {
            position: 'absolute',
            right: 12,
            [theme.breakpoints.down('md')]: {
              top: 34
            }
          },
          '& img': {
            width: 60,
            height: 60,
            marginRight: 16,
            [theme.breakpoints.down('md')]: {
              width: 48,
              height: 48,
              marginRight: 8
            }
          }
        }
      },
      '& .chat-pagination-root': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: 32,
        marginTop: 16
      }
    },
    '& .divider': {
      margin: '40px 0px',
      width: '100%'
    },
    '& .caution-root': {
      position: 'relative',
      padding: 24,
      borderRadius: 10,
      backgroundColor: colorSet.errorLight,
      cursor: 'pointer',
      '& .caution': {
        wordBreak: 'break-all'
      },
      '&.connect': {
        marginTop: 20
      },
      '& .MuiCheckbox-root': {
        position: 'absolute',
        top: 31,
        right: 27,
        width: 18,
        height: 18
      },
      '&.error': {
        border: `1px solid ${colorSet.errorMain}`
      }
    }
  },
  'Member-Withdrawal-Complete-root': {},
  'notificationSettingBox': {
    width: '100%',
    backgroundColor: `${colorSet.gray100}`,
    marginBottom: 0,
    '& .notificationSettingBox-icon': {
      color: `${colorSet.gray700}`
    },
    '& .notificationSettingBox-link': {
      cursor: 'pointer'
    }
  }
}));

export default useStyles;
